import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { MdaiLink } from "../../components/MdaiLink";
import { TilesSection } from "../../components/WhatsNew/TilesSection";
import events from "../../data/events.json";
import { splitEventsByDate } from "./utils/eventDateUtils";

type Event = (typeof events)[number];

const { upcomingEvents, pastEvents } = splitEventsByDate(events);

const keyMatchingEvents = (events: Event[]) => {
  const newEvents = events.map((item) => ({
    ...item,
    link: `/events/${item.id}`,
    linkText: "See Details",
    showDescription: true,
    location: item.location,
    date: `${item.date} • ${item.tag}`,
    imageStyle: {
      backgroundColor: item.backgroundColor,
      objectFit: "contain" as const,
    },
    imageAlt: `${item.title} event image`,
  }));
  return newEvents;
};

export const EventLanding = () => {
  return (
    <Stack gap={4}>
      <TilesSection
        title="Upcoming"
        hasHero={false}
        cards={keyMatchingEvents(upcomingEvents)}
        cardHeight={{ lg: "auto" }}
        cardsPerRow={{ lg: 3 }}
        empty={
          <Stack gap={4}>
            <Stack gap={1}>
              <Typography variant="body1" display={"flex"}>
                No events on the calendar right now, but that'll change soon.
                Want to know when we're hosting something?
              </Typography>
              <MdaiLink
                label="Yes, keep me posted"
                href="#contact-us"
                style={{
                  color: "primary.main",
                }}
              />
            </Stack>
          </Stack>
        }
        afterSection={
          <Typography variant="body1" display={"flex"}>
            Can’t make it to the event?&nbsp;
            <MdaiLink
              label="Schedule a meeting instead"
              href="mailto:info@mydecisive.ai"
              style={{
                color: "primary.main",
              }}
            />
          </Typography>
        }
      />

      <TilesSection
        title="Past Events"
        hasHero={false}
        cards={keyMatchingEvents(pastEvents)}
        cardHeight={{ lg: "auto" }}
        cardsPerRow={{ lg: 3 }}
        empty={
          <Typography component={"h4"} variant="h4">
            Check back soon for exciting content!
          </Typography>
        }
      />
    </Stack>
  );
};
